import { PaginationSize } from "@/common/enum/pagination-size";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { Footnote12Description } from "../../typography/Footnote12Description";
import { CustomCell } from "../CustomCell";
import { Footer } from "./Footer";
import { Row } from "./Row";

interface Props {
  page: BasePageDto<UserDto>;
  handlePageChange: (currentPage: number) => void;
}

const headers = [
  { title: "No", className: "w-[56px] p-0" },
  { title: "파트너명", className: "w-[100px] p-0" },
  { title: "상호명", className: "w-[917px] p-0" },
  { title: "연락처", className: "w-[160px] p-0" },
  { title: "가입코드", className: "w-[112px] p-0" },
  { title: "등급", className: "w-[70px] p-0" },
  { title: "견적 수", className: "w-[67px] p-0" },
  { title: "발주 수", className: "w-[67px] p-0" },
  { title: "총 매출액", className: "w-[113px] p-0" },
  { title: "인센티브 할인", className: "w-[98px] p-0 justify-center" },
  { title: "후불결제", className: "w-[98px] p-0 justify-center" },
];

export const PartnerListTable: React.FC<Props> = ({
  page,
  handlePageChange,
}) => {
  const datas = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_10;

  return (
    <div className="overflow-x-auto rounded-[8px] border">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell className={header.className} key={header.title}>
              <CustomCell>
                <Footnote12Description>{header.title}</Footnote12Description>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {datas.map((data, index) => (
            <Row
              key={data.id}
              data={data}
              index={index}
              startIndex={startIndex}
            />
          ))}
          <Footer
            headers={headers}
            page={page}
            handlePageChange={handlePageChange}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
